/**
 * Slide type aliases — maps compatibility names to their
 * canonical schema names. Generated from the slide manifest so validators,
 * sanitizers, and limit resolvers share the same normalization contract.
 */
import slideManifest from '@digital-twins/slide-schemas/generated/slide-manifest.json';

interface SlideManifestAliases {
  aliases?: {
    validation?: Record<string, string>;
    limits?: Record<string, string>;
  };
}

const manifestAliases = (slideManifest as SlideManifestAliases).aliases ?? {};

export const SLIDE_TYPE_ALIASES: Record<string, string> = manifestAliases.validation ?? {};

/**
 * Overrides for schema limit resolution. Some compatibility aliases map to
 * different canonical schemas when resolving text/item limits vs.
 * when doing slide validation. This map captures those differences.
 */
export const SLIDE_LIMIT_SCHEMA_OVERRIDES: Record<string, string> = manifestAliases.limits ?? {};

export function normalizeSlideType(slideType: string): string {
  return SLIDE_TYPE_ALIASES[slideType] ?? slideType
}

/**
 * Normalize a slide type for schema limit lookups (text-limits, slide-limits).
 * Uses the limit-specific overrides, falling back to the canonical aliases.
 */
export function normalizeSlideTypeForLimits(slideType: string): string {
  return SLIDE_LIMIT_SCHEMA_OVERRIDES[slideType] ?? slideType
}
